import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Mail, MapPinned, Palette, Phone } from 'lucide-react';
import ContactSettingsPanel from './settings/ContactSettingsPanel';
import DesignSettingsPanel from './DesignSettingsPanel';
import KakaoSettingsPanel from './settings/KakaoSettingsPanel';
import MailSettingsPanel from './settings/MailSettingsPanel';

const TABS = [
  { id: 'design', label: '브랜드·디자인', icon: Palette },
  { id: 'contact', label: '연락처', icon: Phone },
  { id: 'mail', label: '메일 서버', icon: Mail },
  { id: 'kakao', label: '카카오 API', icon: MapPinned },
] as const;

type TabId = typeof TABS[number]['id'];

export default function SettingsPage() {
  const [tab, setTab] = useState<TabId>('design');

  return (
    <div className="min-h-full bg-stone-100">
      <Helmet><title>사이트 설정 - COBRAND 관리자</title></Helmet>
      <div className="border-b border-stone-200 bg-white sticky top-0 z-20">
        <div className="max-w-6xl mx-auto px-4 pt-6">
          <h1 className="text-2xl font-bold text-stone-900 mb-5">사이트 설정</h1>
          <div className="flex gap-1 overflow-x-auto" role="tablist" aria-label="사이트 설정 구분">
            {TABS.map(item => {
              const Icon = item.icon;
              const active = tab === item.id;
              return (
                <button key={item.id} type="button" role="tab" aria-selected={active} onClick={() => setTab(item.id)} className={`inline-flex items-center gap-2 px-4 py-3 border-b-2 text-sm font-semibold whitespace-nowrap ${active ? 'border-amber-600 text-stone-900' : 'border-transparent text-stone-500 hover:text-stone-800'}`}>
                  <Icon size={17} aria-hidden="true" />{item.label}
                </button>
              );
            })}
          </div>
        </div>
      </div>
      <div role="tabpanel">
        {tab === 'design' && <DesignSettingsPanel />}
        {tab === 'contact' && <ContactSettingsPanel />}
        {tab === 'mail' && <MailSettingsPanel />}
        {tab === 'kakao' && <KakaoSettingsPanel />}
      </div>
    </div>
  );
}
